/**
 * Account Module — My Account page interactivity.
 *
 * Loaded on: My Account pages only (page type "account", i.e. is_account_page()).
 * Remember LSBB JS is page-type gated: a component rendered elsewhere gets no handler
 * and no console error.
 *
 * What lives here (presentation only):
 *  - Mobile nav: scroll the active item into view.
 *  - Lost-password form: optional always-generic AJAX submit. Only active when the
 *    bb-account-extensions plugin has localised `lsbbAccount.lostPassword`
 *    ({ url, action, nonce }); otherwise the form posts normally to WooCommerce.
 *  - Login/register panel toggle is Alpine (inline x-data in form-login.php).
 *
 * What does NOT live here: the retention cancel flow (Smart Subscription Retention
 * plugin), pause / switch / Premium-ownership modals (bb-account-extensions).
 */

const config = window.lsbbConfig || {};
const account = window.lsbbAccount || {};

function scrollActiveNavIntoView() {
	const list = document.querySelector( '.lsbb-account-nav__list' );
	if ( ! list ) {
		return;
	}
	const active = list.querySelector( 'li.is-active' );
	if ( ! active ) {
		return;
	}
	// Only when the list actually scrolls (mobile).
	if ( list.scrollWidth <= list.clientWidth ) {
		return;
	}
	const left = active.offsetLeft - ( list.clientWidth - active.offsetWidth ) / 2;
	list.scrollTo( { left: Math.max( 0, left ), behavior: 'instant' in window ? 'instant' : 'auto' } );
}

function initLostPasswordAjax() {
	const form = document.getElementById( 'lsbb-lost-password-form' );
	const lp   = account.lostPassword;
	if ( ! form || ! lp || ! lp.url || ! lp.action ) {
		return;
	}

	const notice  = document.getElementById( 'lsbb-lost-password-notice' );
	const button  = form.querySelector( 'button[type="submit"]' );
	const generic = form.dataset.genericMessage || '';
	let busy = false;

	form.addEventListener( 'submit', async ( e ) => {
		e.preventDefault();
		if ( busy ) {
			return;
		}
		busy = true;
		if ( button ) {
			button.disabled = true;
			button.classList.add( 'lsbb-loading' );
		}

		const body = new FormData();
		body.append( 'action', lp.action );
		body.append( 'nonce', lp.nonce || '' );
		body.append( 'user_login', ( form.querySelector( '#user_login' ) || {} ).value || '' );

		let message = generic;
		try {
			const res  = await fetch( lp.url, { method: 'POST', credentials: 'same-origin', body } );
			const json = await res.json();
			if ( json && json.data && json.data.message ) {
				message = json.data.message;
			}
		} catch ( err ) {
			// Stay generic on purpose — never leak whether the address exists.
		}

		if ( notice ) {
			notice.innerHTML = '<div class="lsbb-notice lsbb-notice--info woocommerce-info" role="status">' + message + '</div>';
			notice.hidden = false;
		}
		form.reset();
		busy = false;
		if ( button ) {
			button.disabled = false;
			button.classList.remove( 'lsbb-loading' );
		}
	} );
}

export function init() {
	if ( config.pageType && config.pageType !== 'account' ) {
		return;
	}
	scrollActiveNavIntoView();
	initLostPasswordAjax();
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
